<form [formGroup]="group" (ngSubmit)="save()">
  <mat-card>
  <mat-card-header>Select the parsing formats to use when publishing</mat-card-header>
  <mat-card-content>
    @if( noParsingFormats ) {
      <p class="warning">You need to create at least one parsing format—<em>and save the project</em>—before you create a publication configuration. You can do that under the “Parsing Formats” tab above.</p>
    } @else {
      @for (c of parsingFormatCanons; track c) {
        @if( getParsingFormatArray(c) ) {
        <mat-form-field >
          <mat-label>Select the parsing for the {{c}} canon:</mat-label>
          <mat-select [formControlName]="c">
            @for( key of getParsingFormatArray(c).controls; track key.value?.id ) {
              <mat-option value="{{key.value?.id}}">{{key.value?.id}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @else {
          <p class="warning">There are no formats for {{c}} yet. You won't be able to publish books from this canon until you create a parsing format (under the “Parsing Formats” tab above).</p>
        }
      }
    }
  
    </mat-card-content>
  </mat-card>
  
  <mat-card>
    <mat-card-header>Font/language settings</mat-card-header>
    <mat-card-content>
  
      <mat-form-field>
        <mat-label>Select the typography language</mat-label>
        <mat-select formControlName="polyglossiaOtherLanguage">
          @for( l of polyglossia_languages; track l ) {
            <mat-option value="{{l}}">{{l}}</mat-option>
          }
        </mat-select>
        <mat-hint>If you don't see your language, pick a language that is close to yours.</mat-hint>
      </mat-form-field>
    
      <app-font-selector formControlName="publicationProjectFont" label="Select the font for your language"></app-font-selector>
    
      <mat-checkbox [(ngModel)]="useSblBibLit" [ngModelOptions]="{standalone: true}">Use SBL BibLit for the biblical text</mat-checkbox>
    
      @if( !useSblBibLit ) {
        <div>
          <app-font-selector formControlName="publicationBiblicalFont" label="Select the Biblical language font you wish to use"></app-font-selector>
        </div>
      }
    </mat-card-content>
  </mat-card>
      
  <mat-card>
    <mat-card-header>Chapter Headers</mat-card-header>
    <mat-card-content>
  
      <mat-form-field>
        <mat-label>Show what the chapter header should look like.”</mat-label>
        <input matInput formControlName="chapterHeader" type="text"  [appProjectTextStyle]="project" />
        <mat-hint>Don't change the “__CHAPTER__” part—that's where the number will go.</mat-hint>
        @if( chapterHeader?.invalid && (chapterHeader?.dirty || chapterHeader?.touched) ) {
        <mat-error>
          @if( chapterHeader?.errors?.['required'] ) {
            <span>A chapter header is required.</span>
          }
          @if( chapterHeader?.errors?.['needsChapter'] ) {
            <span>You need to leave “__CHAPTER__” in... that's where the chapter number will go.</span>
          }
        </mat-error>
        }
      </mat-form-field>
      <div class="examples">
        <p>Example:</p>
        <p [appProjectTextStyle]="project">
          {{demoChapterHeader("15")}}
        </p>
      </div>
    
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>Footnotes</mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <mat-label>Choose a footnote style</mat-label>
        <mat-select formControlName="footnote_style">
          <mat-option value="lettered-by-verse">Lettered footnotes, restarting each verse</mat-option>
          <mat-option value="numbered-by-page">Numbered footnotes, restarting each page</mat-option>
        </mat-select>
      </mat-form-field>

      @if( group.get('footnote_style')?.value === 'lettered-by-verse' ) {
        <mat-form-field>
          <mat-label>Enter a list of footnote markers. Place a space between each marker.</mat-label>
          <input matInput formControlName="footnoteMarkers" type="text"  [appProjectTextStyle]="project" />
        </mat-form-field>
        <div class="examples">
          <p>First 32 footnotes:</p>
          <p [appProjectTextStyle]="project">
            {{demoFootnoteMarkers(32)}}
          </p>
        </div>
      }
    </mat-card-content>
  </mat-card>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Custom Frequency Thresholds (advanced)</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-checkbox formControlName="useCustomFrequencyThresholds">Use custom frequency thresholds</mat-checkbox>
    @for (c of parsingFormatCanons; track c) {
      <mat-form-field [formGroup]="customThresholdsGroup">
      <mat-label>Custom Frequency Threshold for {{c}}</mat-label>
      <input matInput [formControlName]="c" type="number" />
      </mat-form-field>
    }
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>LaTex Template (advanced)</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-form-field>
      <mat-label>LaTeX Template</mat-label>
      <textarea matInput placeholder="Your project's LaTeX template" formControlName="latex_template"></textarea>
    </mat-form-field>
    <button mat-button type="button" (click)="resetLatexTemplate()">
      <mat-icon>delete</mat-icon>
      Reset to default
    </button>
  </mat-expansion-panel>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>CSS Template (advanced)</mat-panel-title>
    </mat-expansion-panel-header>
    <mat-form-field>
      <mat-label>CSS Template</mat-label>
      <textarea matInput placeholder="Your project's CSS template" formControlName="css_template"></textarea>
    </mat-form-field>
    <button mat-button type="button" (click)="resetCSSTemplate()">
      <mat-icon>delete</mat-icon>
      Clear CSS template
    </button>
  </mat-expansion-panel>

  @if(control.value.id !== 'default') {
    <button mat-button type="button" (click)="deleteConfiguration()" color="warn" id="deleteConfigurationButton">
      <mat-icon>delete</mat-icon>
      Delete “{{control.value.id}}”
    </button>
  }
  </form>

